module.exports = __webpack_public_path__ + "img/ggA_Spalt.02f831fb.png";